import MuiDialog from "@mui/material/Dialog";

import useBreakpoints from "../common/hooks/useBreakpoint";

const Dialog = (props) => {
  const fullScreen = useBreakpoints("sm");

  return (
    <MuiDialog {...props} fullScreen={fullScreen}>
      {props.children}
    </MuiDialog>
  );
};

export default Dialog;
